import { Environment } from '@classifieds-sell/environment';
import { defaultEnvironment } from './environment.default';

// noinspection JSUnusedGlobalSymbols
export const environment: Environment = {
    ...defaultEnvironment,
    authUrl: 'https://stage.auth.trademe.co.nz',
    name: 'stage',
    production: false
};
